// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'auth.loginPage.heroAlt': 'Caminhão graneleiro TransGrãos',
    'auth.loginPage.welcomeTitle': 'Bem-vindo de volta',
    'auth.loginPage.welcomeSubtitle': 'Entre para acessar o painel.',
    'auth.loginPage.emailLabel': 'E-mail',
    'auth.loginPage.emailPlaceholder': 'voce@transgraos.com.br',
    'auth.loginPage.passwordLabel': 'Senha',
    'auth.loginPage.showPassword': 'Mostrar senha',
    'auth.loginPage.hidePassword': 'Ocultar senha',
    'auth.loginPage.rememberMe': 'Lembrar de mim',
    'auth.loginPage.forgotPassword': 'Esqueceu a senha?',
    'auth.loginPage.signIn': 'Entrar',
    'auth.loginPage.signingIn': 'Entrando…',
    'auth.loginPage.mfaCodeLabel': 'Código de verificação',
    'auth.loginPage.mfaHint':
      'Abra o aplicativo autenticador e informe o código do momento. Se você perdeu o aparelho, use um dos códigos de recuperação.',
    'auth.loginPage.verify': 'Verificar',
    'auth.loginPage.verifying': 'Verificando…',
    'auth.loginPage.useAnotherAccount': 'Usar outra conta',
    'auth.loginPage.poweredBy': 'Desenvolvido por',
    'auth.loginPage.poweredByAria': 'Desenvolvido por {{brand}}',
    'auth.loginPage.emailRequired': 'Informe o e-mail',
    'auth.loginPage.emailInvalid': 'E-mail inválido',
    'auth.loginPage.passwordRequired': 'Informe a senha',
    'auth.loginPage.errInvalidCredentials': 'E-mail ou senha inválidos.',
    'auth.loginPage.errAccountBlocked': 'Conta bloqueada. Fale com o suporte.',
    'auth.loginPage.errAccountNotActivated': 'Conta não ativada. Verifique o e-mail de ativação.',
    'auth.loginPage.errNetwork': 'Sem conexão com o servidor. Tente novamente.',
    'auth.loginPage.errValidation': 'Preencha e-mail e senha.',
    'auth.loginPage.errGeneric': 'Não foi possível entrar.',
  },
  en: {
    'auth.loginPage.heroAlt': 'TransGrãos grain truck',
    'auth.loginPage.welcomeTitle': 'Welcome back',
    'auth.loginPage.welcomeSubtitle': 'Sign in to access the dashboard.',
    'auth.loginPage.emailLabel': 'Email',
    'auth.loginPage.emailPlaceholder': 'you@transgraos.com.br',
    'auth.loginPage.passwordLabel': 'Password',
    'auth.loginPage.showPassword': 'Show password',
    'auth.loginPage.hidePassword': 'Hide password',
    'auth.loginPage.rememberMe': 'Remember me',
    'auth.loginPage.forgotPassword': 'Forgot your password?',
    'auth.loginPage.signIn': 'Sign in',
    'auth.loginPage.signingIn': 'Signing in…',
    'auth.loginPage.mfaCodeLabel': 'Verification code',
    'auth.loginPage.mfaHint':
      'Open your authenticator app and enter the current code. If you lost your device, use one of your recovery codes.',
    'auth.loginPage.verify': 'Verify',
    'auth.loginPage.verifying': 'Verifying…',
    'auth.loginPage.useAnotherAccount': 'Use another account',
    'auth.loginPage.poweredBy': 'Powered by',
    'auth.loginPage.poweredByAria': 'Powered by {{brand}}',
    'auth.loginPage.emailRequired': 'Enter your email',
    'auth.loginPage.emailInvalid': 'Invalid email',
    'auth.loginPage.passwordRequired': 'Enter your password',
    'auth.loginPage.errInvalidCredentials': 'Invalid email or password.',
    'auth.loginPage.errAccountBlocked': 'Account blocked. Contact support.',
    'auth.loginPage.errAccountNotActivated': 'Account not activated. Check your activation email.',
    'auth.loginPage.errNetwork': 'No connection to the server. Try again.',
    'auth.loginPage.errValidation': 'Enter your email and password.',
    'auth.loginPage.errGeneric': 'Could not sign in.',
  },
  es: {
    'auth.loginPage.heroAlt': 'Camión granelero TransGrãos',
    'auth.loginPage.welcomeTitle': 'Bienvenido de nuevo',
    'auth.loginPage.welcomeSubtitle': 'Inicia sesión para acceder al panel.',
    'auth.loginPage.emailLabel': 'Correo electrónico',
    'auth.loginPage.emailPlaceholder': 'usted@transgraos.com.br',
    'auth.loginPage.passwordLabel': 'Contraseña',
    'auth.loginPage.showPassword': 'Mostrar contraseña',
    'auth.loginPage.hidePassword': 'Ocultar contraseña',
    'auth.loginPage.rememberMe': 'Recordarme',
    'auth.loginPage.forgotPassword': '¿Olvidaste tu contraseña?',
    'auth.loginPage.signIn': 'Iniciar sesión',
    'auth.loginPage.signingIn': 'Iniciando sesión…',
    'auth.loginPage.mfaCodeLabel': 'Código de verificación',
    'auth.loginPage.mfaHint':
      'Abre la aplicación de autenticación e ingresa el código actual. Si perdiste el dispositivo, usa uno de los códigos de recuperación.',
    'auth.loginPage.verify': 'Verificar',
    'auth.loginPage.verifying': 'Verificando…',
    'auth.loginPage.useAnotherAccount': 'Usar otra cuenta',
    'auth.loginPage.poweredBy': 'Desarrollado por',
    'auth.loginPage.poweredByAria': 'Desarrollado por {{brand}}',
    'auth.loginPage.emailRequired': 'Ingresa el correo',
    'auth.loginPage.emailInvalid': 'Correo inválido',
    'auth.loginPage.passwordRequired': 'Ingresa la contraseña',
    'auth.loginPage.errInvalidCredentials': 'Correo o contraseña inválidos.',
    'auth.loginPage.errAccountBlocked': 'Cuenta bloqueada. Contacta con soporte.',
    'auth.loginPage.errAccountNotActivated': 'Cuenta no activada. Revisa el correo de activación.',
    'auth.loginPage.errNetwork': 'Sin conexión con el servidor. Inténtalo de nuevo.',
    'auth.loginPage.errValidation': 'Ingresa el correo y la contraseña.',
    'auth.loginPage.errGeneric': 'No se pudo iniciar sesión.',
  },
}
